// import { useState, useEffect } from "react";
// import { CURRENCY_MAP } from "../../constants";
// import { useCartStore } from "../../store/cartStore";

// export default function TicketTypes({ event }) {
//   return (
//     <div className="mt-4 mb-6">
//       {/* STEPPER */}
//       <div className="w-full max-w-4xl mx-auto mt-12 mb-6">
//         <div className="flex items-center w-full text-xs text-green-400/70">
//           <Step number="1" label="TIPO DE ENTRADA" active />
//           <Line />
//           <Step number="2" label="CONFIRMAR" />
//         </div>
//       </div>

//       {/* TITLE */}
//       <p className="text-[10px] tracking-widest text-green-400/70 uppercase">
//         PASO 1
//       </p>
//       <h2 className="text-2xl md:text-3xl font-semibold mt-1 mb-6">
//         Elige tu Acceso
//       </h2>
//       {/* TICKET CARDS */}
//       <div className="flex flex-col gap-4">
//         {event.ticket_types.map((ticket) => (
//           <TicketCard
//             key={ticket.id}
//             ticket={ticket}
//             event={event}
//             currency={event.currency}
//           />
//         ))}
//       </div>
//     </div>
//   );
// }

// /* ── STEPPER HELPERS ── */

// function Line() {
//   return <div className="flex-1 h-px bg-green-900/30 mx-4" />;
// }

// function Step({ number, label, active }) {
//   return (
//     <div className="flex items-center gap-3 shrink-0">
//       <div
//         className={`w-7 h-7 flex items-center justify-center rounded-full text-xs
//           ${
//             active
//               ? "bg-green-500 text-black"
//               : "border border-green-500/30 text-green-400"
//           }`}
//       >
//         {number}
//       </div>
//       <span className="hidden md:block whitespace-nowrap">{label}</span>
//     </div>
//   );
// }

// /* ── PRESALE COUNTDOWN HOOK ── */

// function usePresaleCountdown(saleStart) {
//   const getSecondsLeft = () => {
//     if (!saleStart) return 0;
//     const diff = new Date(saleStart).getTime() - Date.now();
//     return Math.max(0, Math.floor(diff / 1000));
//   };

//   const [secondsLeft, setSecondsLeft] = useState(getSecondsLeft);

//   useEffect(() => {
//     if (!saleStart) return;
//     const interval = setInterval(() => {
//       const s = getSecondsLeft();
//       setSecondsLeft(s);
//       if (s <= 0) clearInterval(interval);
//     }, 1000);
//     return () => clearInterval(interval);
//   }, [saleStart]);

//   const days = Math.floor(secondsLeft / 86400);
//   const hours = Math.floor((secondsLeft % 86400) / 3600);
//   const minutes = Math.floor((secondsLeft % 3600) / 60);
//   const seconds = secondsLeft % 60;

//   const pad = (n) => String(n).padStart(2, "0");

//   return {
//     expired: secondsLeft <= 0,
//     days,
//     hours: pad(hours),
//     minutes: pad(minutes),
//     seconds: pad(seconds),
//   };
// }

// /* ── COUNTDOWN DISPLAY ── */

// function PresaleCountdown({ saleStart }) {
//   const { expired, days, hours, minutes, seconds } =
//     usePresaleCountdown(saleStart);

//   if (expired) return null;

//   return (
//     <div className="flex items-center gap-1.5 flex-shrink-0">
//       {/* LABEL */}
//       <span className="text-[10px] tracking-widest text-gray-400 uppercase mr-1 hidden sm:block">
//         Venta en
//       </span>

//       {/* TIME BLOCKS */}
//       {days > 0 && (
//         <>
//           <TimeBlock value={days} label="d" />
//           <Colon />
//         </>
//       )}
//       <TimeBlock value={hours} label="h" />
//       <Colon />
//       <TimeBlock value={minutes} label="m" />
//       <Colon />
//       <TimeBlock value={seconds} label="s" />
//     </div>
//   );
// }

// function TimeBlock({ value, label }) {
//   return (
//     <div className="flex flex-col items-center bg-[#021610] border border-green-900/40 rounded-lg px-2 py-1 min-w-[32px]">
//       <span className="text-sm font-mono font-semibold text-green-400 tabular-nums leading-none">
//         {value}
//       </span>
//       <span className="text-[8px] text-gray-500 uppercase tracking-wider leading-none mt-0.5">
//         {label}
//       </span>
//     </div>
//   );
// }

// function Colon() {
//   return (
//     <span className="text-green-900 font-bold text-sm leading-none">:</span>
//   );
// }

// function SellingDate({ saleStart }) {
//   if (!saleStart) return null;
//   const formatted = new Date(saleStart).toLocaleDateString("es-ES", {
//     day: "numeric",
//     month: "short",
//     year: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//   });
//   return (
//     <div className="flex items-center gap-2 flex-shrink-0">
//       <span className="text-[10px] tracking-widest text-gray-400 uppercase hidden sm:block">
//         Venta desde
//       </span>
//       <span className="text-xs font-medium text-green-400 border border-green-900/40 bg-[#021610] rounded-lg px-3 py-1.5">
//         {formatted}
//       </span>
//     </div>
//   );
// }

// /* ── TICKET CARD ── */

// function TicketCard({ ticket, event, currency }) {
//   console.log("--", ticket); // --- IGNORE ---
//   const [open, setOpen] = useState(false);
//   const [qty, setQty] = useState(1);
//   const [added, setAdded] = useState(false);

//   const addItem = useCartStore((s) => s.addItem);
//   const openDrawer = useCartStore((s) => s.openDrawer);

//   // const isSoldOut = ticket.display_status === "sold_out";
//   // const isComingSoon = ticket.display_status === "coming_soon";

//   // // Check if ticket is in presale countdown mode
//   // const isPresaleCountdown =
//   //   ticket.pre_sale_display_mode === "countdown" &&
//   //   ticket.sale_start != null &&
//   //   new Date(ticket.sale_start).getTime() > Date.now();

//   const isSoldOut = ticket.display_status === "sold_out";
//   const isOnSale = ticket.display_status === "on_sale";
//   const displayBeforeSale = ticket.display_before_sale === true;
//   const preSaleMode = ticket.pre_sale_display_mode;

//   const showCountdown =
//     !isSoldOut &&
//     displayBeforeSale &&
//     preSaleMode === "countdown" &&
//     ticket.sale_start != null;

//   const showSellingDate =
//     !isSoldOut &&
//     displayBeforeSale &&
//     preSaleMode === "display_start_selling_date" &&
//     ticket.sale_start != null;

//   const showComingSoon =
//     !isSoldOut && !displayBeforeSale && ticket.is_display_on_sold_out === true;

//   const showQtySelector = !isSoldOut && displayBeforeSale && !showComingSoon && isOnSale;

//   const canAddToCart = showQtySelector;

//   // Remaining stock — this is the hard cap for the + button
//   const remaining =
//     ticket.quantity_total != null && ticket.quantity_sold != null
//       ? Math.max(0, ticket.quantity_total - ticket.quantity_sold)
//       : 20; // fallback if keys are missing

//   const atMax = qty >= remaining;

//   const formatCurrency = (amount, cur) => {
//     const symbol = CURRENCY_MAP[cur] || cur;
//     return `${symbol} ${parseFloat(amount).toFixed(2)}`;
//   };

//   const handleAddToCart = () => {
//     if (isSoldOut || remaining === 0) return;
//     addItem(event, ticket, qty);
//     setAdded(true);
//     setQty(1);
//     openDrawer();
//     setTimeout(() => setAdded(false), 2000);
//   };

//   return (
//     <div className="relative p-5 rounded-xl bg-[#03211a] overflow-hidden">
//       {/* TICKET STUB CUTS */}
//       <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 w-6 h-6 bg-[#021610] rounded-full z-10" />
//       <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 w-6 h-6 bg-[#021610] rounded-full z-10" />

//       {/* ROW 1: NAME + SOLD OUT / COUNTDOWN / QTY */}
//       <div className="flex items-center justify-between gap-4">
//         <h3 className="text-lg font-semibold">{ticket.name}</h3>

//         {/* SOLD OUT */}
//         {isSoldOut && (
//           <span className="px-3 py-1 rounded-full border border-red-500 text-red-300 text-xs tracking-widest uppercase flex-shrink-0">
//             Sold Out
//           </span>
//         )}

//         {showComingSoon && (
//           <span className="px-3 py-1 rounded-full border border-yellow-500 text-yellow-300 text-xs tracking-widest uppercase flex-shrink-0">
//             Coming Soon
//           </span>
//         )}

//         {showCountdown && <PresaleCountdown saleStart={ticket.sale_start} />}

//         {showSellingDate && <SellingDate saleStart={ticket.sale_start} />}

//         {showQtySelector && (
//           <div className="flex items-center justify-between gap-4">
//             {ticket.sale_tag !== null && (
//               <span
//                 className="text-[10px] tracking-widest uppercase px-3 py-2 rounded-full font-medium flex-shrink-0"
//                 style={{
//                   backgroundColor: `${ticket.sale_tag?.color}70`,
//                   color: ticket.sale_tag?.color,
//                   border: `1px solid ${ticket.sale_tag?.color}`,
//                 }}
//               >
//                 {ticket.sale_tag?.label}
//               </span>
//             )}
//             <div className="flex items-center gap-1.5 bg-[#021610] rounded-full px-1 py-1 border border-green-900/40">
//               <button
//                 onClick={() => setQty((q) => Math.max(1, q - 1))}
//                 className="w-7 h-7 rounded-full text-green-400 hover:bg-green-900/50 transition flex items-center justify-center text-base leading-none"
//               >
//                 −
//               </button>
//               <span className="text-sm w-5 text-center tabular-nums">
//                 {qty}
//               </span>
//               <button
//                 onClick={() => setQty((q) => Math.min(remaining, q + 1))}
//                 disabled={atMax}
//                 className={`w-7 h-7 rounded-full transition flex items-center justify-center text-base leading-none
//           ${atMax ? "text-green-900 cursor-not-allowed" : "text-green-400 hover:bg-green-900/50"}`}
//               >
//                 +
//               </button>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* DOTTED DIVIDER */}
//       <div className="border-t border-dashed border-green-900/60 my-4" />

//       {/* ROW 2: PRICE + ACTIONS */}
//       <div className="flex items-center justify-between gap-4 flex-wrap">
//         {/* LEFT: PRICE */}
//         <div className="flex items-center gap-3 flex-wrap">
//           <p className="text-xl font-semibold text-green-400">
//             {formatCurrency(ticket.price, currency)}
//           </p>
//         </div>

//         {/* RIGHT: MORE INFO + ADD TO CART (hidden during presale countdown) */}
//         {canAddToCart ? (
//           <div className="flex items-center gap-3">
//             {ticket.description && (
//               <button
//                 onClick={() => setOpen(!open)}
//                 className="text-xs text-green-400/60 hover:text-green-300 transition"
//               >
//                 {open ? "Menos ▲" : "Más info ▼"}
//               </button>
//             )}

//             <button
//               onClick={handleAddToCart}
//               className={`px-4 py-2 rounded-full border text-xs tracking-widest uppercase transition font-medium
//                 ${
//                   added
//                     ? "border-green-400 bg-green-500 text-black"
//                     : "border-green-500 text-green-300 hover:bg-green-500 hover:text-black"
//                 }`}
//             >
//               {added ? "✓ Añadido" : "Añadir"}
//             </button>
//           </div>
//         ) : (
//           /* MORE INFO still available during presale and sold out */
//           ticket.description && (
//             <button
//               onClick={() => setOpen(!open)}
//               className="text-xs text-green-400/60 hover:text-green-300 transition"
//             >
//               {open ? "Menos ▲" : "Más info ▼"}
//             </button>
//           )
//         )}
//       </div>

//       {/* EXPAND — description */}
//       {open && ticket.description && (
//         <div className="mt-4 pt-4 border-t border-green-900/30">
//           <p className="text-sm text-gray-300 leading-relaxed whitespace-pre-line">
//             {ticket.description}
//           </p>
//           {ticket.tickets_per_order > 1 && (
//             <p className="text-[10px] tracking-widest text-green-400/60 uppercase mt-3">
//               {`Incluye ${ticket.tickets_per_order} entradas por unidad`}
//             </p>
//           )}
//           {ticket.is_display_total_available_tickets &&
//             ticket.quantity_total != null &&
//             ticket.quantity_sold != null && (
//               <p className="text-[10px] tracking-widest text-gray-400 uppercase mt-2">
//                 {Math.max(0, ticket.quantity_total - ticket.quantity_sold)}{" "}
//                 disponibles
//               </p>
//             )}
//         </div>
//       )}
//     </div>
//   );
// }

import { useState, useEffect } from "react";
import { CURRENCY_MAP } from "../../constants";
import { useCartStore } from "../../store/cartStore";
import { usePixel } from "../../hooks/usePixel";
import { DateTime } from "luxon";

export default function TicketTypes({ event }) {
  return (
    <div className="mt-4 mb-6">
      {/* STEPPER */}
      <div className="w-full max-w-4xl mx-auto mt-12 mb-6">
        <div className="flex items-center w-full text-xs text-green-400/70">
          <Step number="1" label="TIPO DE ENTRADA" active />
          <Line />
          <Step number="2" label="CONFIRMAR" />
        </div>
      </div>

      {/* TITLE */}
      <p className="text-[10px] tracking-widest text-green-400/70 uppercase">
        PASO 1
      </p>
      <h2 className="text-2xl md:text-3xl font-semibold mt-1 mb-6">
        Elige tu Acceso
      </h2>
      {/* TICKET CARDS */}

      {!event.ticket_types?.length ? (
        <div className="flex flex-col items-center justify-center py-16 px-6 rounded-xl bg-[#03211a] border border-green-900/30 text-center">
          <div className="w-12 h-12 rounded-full bg-green-900/20 flex items-center justify-center mb-4">
            <svg
              className="w-6 h-6 text-green-900"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a3 3 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z"
              />
            </svg>
          </div>
          <p className="text-base font-medium text-green-400/60">
            El promotor aún no ha iniciado la venta de entradas.
          </p>
          <p className="text-xs text-white mt-1">
            Por favor, consulta su comunicación para más información.
          </p>
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          {event.ticket_types.map((ticket) => (
            <TicketCard
              key={ticket.id}
              ticket={ticket}
              event={event}
              currency={event.currency}
            />
          ))}
        </div>
      )}
    </div>
  );
}

/* ── STEPPER HELPERS ── */

function Line() {
  return <div className="flex-1 h-px bg-green-900/30 mx-4" />;
}

function Step({ number, label, active }) {
  return (
    <div className="flex items-center gap-3 shrink-0">
      <div
        className={`w-7 h-7 flex items-center justify-center rounded-full text-xs
          ${
            active
              ? "bg-green-500 text-black"
              : "border border-green-500/30 text-green-400"
          }`}
      >
        {number}
      </div>
      <span className="hidden md:block whitespace-nowrap">{label}</span>
    </div>
  );
}

/* ── PRESALE COUNTDOWN HOOK ── */

// function usePresaleCountdown(saleStart) {
//   const getSecondsLeft = () => {
//     if (!saleStart) return 0;
//     const diff = new Date(saleStart).getTime() - Date.now();
//     return Math.max(0, Math.floor(diff / 1000));
//   };

//   const [secondsLeft, setSecondsLeft] = useState(getSecondsLeft);

//   useEffect(() => {
//     if (!saleStart) return;
//     const interval = setInterval(() => {
//       const s = getSecondsLeft();
//       setSecondsLeft(s);
//       if (s <= 0) clearInterval(interval);
//     }, 1000);
//     return () => clearInterval(interval);
//   }, [saleStart]);

//   const days = Math.floor(secondsLeft / 86400);
//   const hours = Math.floor((secondsLeft % 86400) / 3600);
//   const minutes = Math.floor((secondsLeft % 3600) / 60);
//   const seconds = secondsLeft % 60;

//   const pad = (n) => String(n).padStart(2, "0");

//   return {
//     expired: secondsLeft <= 0,
//     days,
//     hours: pad(hours),
//     minutes: pad(minutes),
//     seconds: pad(seconds),
//   };
// }

function usePresaleCountdown(saleStart, timezone) {
  const getSecondsLeft = () => {
    if (!saleStart) return 0;

    let saleTime;

    if (timezone) {
      // Parse the sale_start in the event's timezone
      saleTime = DateTime.fromISO(saleStart, { zone: timezone });
    } else {
      // Fallback — parse as UTC if no timezone provided
      saleTime = DateTime.fromISO(saleStart, { zone: "utc" });
    }

    const diff = saleTime.toMillis() - Date.now();
    return Math.max(0, Math.floor(diff / 1000));
  };

  const [secondsLeft, setSecondsLeft] = useState(getSecondsLeft);

  useEffect(() => {
    if (!saleStart) return;
    const interval = setInterval(() => {
      const s = getSecondsLeft();
      setSecondsLeft(s);
      if (s <= 0) clearInterval(interval);
    }, 1000);
    return () => clearInterval(interval);
  }, [saleStart, timezone]);

  const days = Math.floor(secondsLeft / 86400);
  const hours = Math.floor((secondsLeft % 86400) / 3600);
  const minutes = Math.floor((secondsLeft % 3600) / 60);
  const seconds = secondsLeft % 60;
  const pad = (n) => String(n).padStart(2, "0");

  return {
    expired: secondsLeft <= 0,
    days,
    hours: pad(hours),
    minutes: pad(minutes),
    seconds: pad(seconds),
  };
}

/* ── COUNTDOWN DISPLAY ── */

function PresaleCountdown({ saleStart, timezone }) {
  const { expired, days, hours, minutes, seconds } = usePresaleCountdown(
    saleStart,
    timezone,
  );

  if (expired) return null;

  return (
    <div className="flex items-center gap-1.5 flex-shrink-0">
      {/* LABEL */}
      <span className="text-[10px] tracking-widest text-gray-400 uppercase mr-1 hidden sm:block">
        Venta en
      </span>

      {/* TIME BLOCKS */}
      {days > 0 && (
        <>
          <TimeBlock value={days} label="d" />
          <Colon />
        </>
      )}
      <TimeBlock value={hours} label="h" />
      <Colon />
      <TimeBlock value={minutes} label="m" />
      <Colon />
      <TimeBlock value={seconds} label="s" />
    </div>
  );
}

function TimeBlock({ value, label }) {
  return (
    <div className="flex flex-col items-center bg-[#021610] border border-green-900/40 rounded-lg px-2 py-1 min-w-[32px]">
      <span className="text-sm font-mono font-semibold text-green-400 tabular-nums leading-none">
        {value}
      </span>
      <span className="text-[8px] text-gray-500 uppercase tracking-wider leading-none mt-0.5">
        {label}
      </span>
    </div>
  );
}

function Colon() {
  return (
    <span className="text-green-900 font-bold text-sm leading-none">:</span>
  );
}

/* ── SELLING DATE DISPLAY ── */

function SellingDate({ saleStart }) {
  if (!saleStart) return null;

  const formatted = new Date(saleStart).toLocaleDateString("es-ES", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div className="flex items-center gap-2 flex-shrink-0">
      <span className="text-[10px] tracking-widest text-gray-400 uppercase hidden sm:block">
        Venta desde
      </span>
      <span className="text-xs font-medium text-green-400 border border-green-900/40 bg-[#021610] rounded-lg px-3 py-1.5">
        {formatted}
      </span>
    </div>
  );
}

/* ── TICKET CARD ── */

function TicketCard({ ticket, event, currency }) {
  const { trackEvent } = usePixel(event?.pixels || []);

  const [open, setOpen] = useState(false);
  const [qty, setQty] = useState(1);
  const [added, setAdded] = useState(false);

  const addItem = useCartStore((s) => s.addItem);
  const openDrawer = useCartStore((s) => s.openDrawer);

  const isSoldOut = ticket.display_status === "sold_out";
  const isOnSale = ticket.display_status === "on_sale";
  const isComingSoon = ticket.display_status === "coming_soon";

  // coming_soon breakdown
  const showComingSoonBadge =
    isComingSoon && ticket.is_display_on_sold_out === true;
  const showCountdown =
    isComingSoon &&
    ticket.is_display_on_sold_out === false &&
    ticket.pre_sale_display_mode === "countdown" &&
    ticket.sale_start != null;
  const showSellingDate =
    isComingSoon &&
    ticket.is_display_on_sold_out === false &&
    ticket.pre_sale_display_mode === "display_start_selling_date" &&
    ticket.sale_start != null;

  // Remaining stock — this is the hard cap for the + button
  const remaining =
    ticket.quantity_total != null && ticket.quantity_sold != null
      ? Math.max(0, ticket.quantity_total - ticket.quantity_sold)
      : 20; // fallback if keys are missing

  const atMax = qty >= remaining;

  const formatCurrency = (amount, cur) => {
    const symbol = CURRENCY_MAP[cur] || cur;
    return `${symbol} ${parseFloat(amount).toFixed(2)}`;
  };

  const handleAddToCart = () => {
    if (!isOnSale || remaining === 0) return;
    addItem(event, ticket, qty);

    trackEvent("AddToCart", {
      content_name: ticket.name,
      content_ids: [ticket.id],
      value: ticket.price,
      currency: currency,
    });

    setAdded(true);
    setQty(1);
    openDrawer();
    setTimeout(() => setAdded(false), 2000);
  };

  return (
    <div className="relative p-5 rounded-xl bg-[#03211a] overflow-hidden">
      {/* TICKET STUB CUTS */}
      <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 w-6 h-6 bg-[#021610] rounded-full z-10" />
      <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 w-6 h-6 bg-[#021610] rounded-full z-10" />

      {/* ROW 1: NAME + RIGHT SIDE */}
      <div className="flex items-center justify-between gap-4">
        <div>
          <h3 className="text-lg font-semibold">{ticket.name}</h3>
          <p className="text-xs font-medium text-green-400/60">{ticket.subtitle}</p>
        </div>

        {/* SOLD OUT */}
        {isSoldOut && (
          <span className="px-3 py-1 rounded-full border border-red-500 text-red-300 text-xs tracking-widest uppercase flex-shrink-0">
            Sold Out
          </span>
        )}

        {/* COMING SOON BADGE */}
        {showComingSoonBadge && (
          <span className="px-3 py-1 rounded-full border border-yellow-500 text-yellow-300 text-xs tracking-widest uppercase flex-shrink-0">
            Coming Soon
          </span>
        )}

        {/* COUNTDOWN */}

        {/* COUNTDOWN */}
        {showCountdown && (
          <PresaleCountdown
            saleStart={ticket.sale_start}
            timezone={event.timezone}
          />
        )}

        {/* SELLING DATE */}
        {showSellingDate && <SellingDate saleStart={ticket.sale_start} />}

        {/* ON SALE — QTY SELECTOR */}
        {isOnSale && (
          <div className="flex items-center justify-between gap-4">
            {ticket.sale_tag !== null && (
              <span
                className="text-[10px] tracking-widest uppercase px-3 py-2 rounded-full font-medium flex-shrink-0"
                style={{
                  color: ticket.sale_tag?.color,
                  border: `1px solid ${ticket.sale_tag?.color}`,
                }}
              >
                {ticket.sale_tag?.label}
              </span>
            )}
            <div className="flex items-center gap-1.5 bg-[#021610] rounded-full px-1 py-1 border border-green-900/40">
              <button
                onClick={() => setQty((q) => Math.max(1, q - 1))}
                className="w-7 h-7 rounded-full text-green-400 hover:bg-green-900/50 transition flex items-center justify-center text-base leading-none"
              >
                −
              </button>
              <span className="text-sm w-5 text-center tabular-nums">
                {qty}
              </span>
              <button
                onClick={() => setQty((q) => Math.min(remaining, q + 1))}
                disabled={atMax}
                className={`w-7 h-7 rounded-full transition flex items-center justify-center text-base leading-none
                  ${
                    atMax
                      ? "text-green-900 cursor-not-allowed"
                      : "text-green-400 hover:bg-green-900/50"
                  }`}
              >
                +
              </button>
            </div>
          </div>
        )}
      </div>

      {/* DOTTED DIVIDER */}
      <div className="border-t border-dashed border-green-900/60 my-4" />

      {/* ROW 2: PRICE + ACTIONS */}
      <div className="flex items-center justify-between gap-4 flex-wrap">
        {/* LEFT: PRICE */}
        <div className="flex items-center gap-3 flex-wrap">
          <p className="text-xl font-semibold text-green-400">
            {formatCurrency(ticket.price, currency)}
          </p>
        </div>

        {/* RIGHT: ADD TO CART only when on_sale, otherwise just MORE INFO */}
        {isOnSale ? (
          <div className="flex items-center gap-3">
            {ticket.description && (
              <button
                onClick={() => setOpen(!open)}
                className="text-xs text-green-400/60 hover:text-green-300 transition"
              >
                {open ? "Menos ▲" : "Más info ▼"}
              </button>
            )}
            <button
              onClick={handleAddToCart}
              className={`px-4 py-2 rounded-full border text-xs tracking-widest uppercase transition font-medium
                ${
                  added
                    ? "border-green-400 bg-green-500 text-black"
                    : "border-green-500 text-green-300 hover:bg-green-500 hover:text-black"
                }`}
            >
              {added ? "✓ Añadido" : "Añadir"}
            </button>
          </div>
        ) : (
          ticket.description && (
            <button
              onClick={() => setOpen(!open)}
              className="text-xs text-green-400/60 hover:text-green-300 transition"
            >
              {open ? "Menos ▲" : "Más info ▼"}
            </button>
          )
        )}
      </div>

      {/* EXPAND — description */}
      {open && ticket.description && (
        <div className="mt-4 pt-4 border-t border-green-900/30">
          <p className="text-sm text-gray-300 leading-relaxed whitespace-pre-line">
            {ticket.description}
          </p>
          {ticket.tickets_per_order > 1 && (
            <p className="text-[10px] tracking-widest text-green-400/60 uppercase mt-3">
              {`Incluye ${ticket.tickets_per_order} entradas por unidad`}
            </p>
          )}
          {ticket.is_display_total_available_tickets &&
            ticket.quantity_total != null &&
            ticket.quantity_sold != null && (
              <p className="text-[10px] tracking-widest text-gray-400 uppercase mt-2">
                {Math.max(0, ticket.quantity_total - ticket.quantity_sold)}{" "}
                disponibles
              </p>
            )}
        </div>
      )}
    </div>
  );
}
